module.exports = __webpack_public_path__ + "assets/img/reserving.eff1de27bb93206a0c3ff0c6f87e71f3.png";